import React from "react";
import commission_1 from "../../../assets/images/outer/commission_1.svg";
import commission_2 from "../../../assets/images/outer/commission_2.svg";
import commission_3 from "../../../assets/images/outer/commission_3.svg";
import { APP_ROUTES } from "../../../system/constants/constantsUrl";
import { _t } from "../../Common/components/InjectIntlContext";
import InfoCard from "./InfoCard";
import { Typography } from "antd";
import CommissionCard from "./CommissionCard";

const commissions = (_t: any) => [
  {
    title: _t("revshare_commission"),
    image: commission_1,
    linkTo: APP_ROUTES.commissions.revshare,
    text: _t("revshare_commission_desc"),
  },
  {
    title: _t("cpa_program"),
    image: commission_2,
    linkTo: APP_ROUTES.commissions.cpa,
    text: _t("cpa_program_desc"),
  },
  {
    title: _t("subaffiliate_program"),
    image: commission_3,
    linkTo: APP_ROUTES.commissions.subaffiliate,
    text: _t("subaffiliate_program_desc"),
  },
];

const Commissions = () => {
  const commissionsTranslated = commissions(_t);
  const commissionItem = (card, idx) => (
    <CommissionCard info={card} key={card.title + idx} />
  );
  return (
    <section className="commissions custom-section">
      <div className="container">
        <Typography.Title level={2} className="custom-section__title">
          {_t("Commissions")}
        </Typography.Title>
        <div className="commissions-grid">
          {commissionsTranslated.map(commissionItem)}
        </div>
      </div>
    </section>
  );
};

export default Commissions;
